export { getDomain } from './getDomain';
